// Helpers partagés pour les documents joints aux habilitations
// (utilisés par HabilitationDocuments.js et la liste Habilitations.js).

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getHabilitationDocMimeType = (fileType) => {
  if (fileType === 'pdf') return 'application/pdf';
  if (['jpg', 'jpeg'].includes(fileType)) return 'image/jpeg';
  if (fileType === 'png') return 'image/png';
  return 'application/octet-stream';
};

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

/**
 * Récupère le contenu d'un document d'habilitation (GET /habilitations/documents/{docId}).
 * Retourne { content (base64), filename, file_type } ou lève une erreur.
 */
export const fetchHabilitationDocument = async (docId) => {
  const response = await fetch(`${BACKEND_URL}/api/habilitations/documents/${docId}`, {
    headers: authHeaders()
  });
  if (!response.ok) throw new Error('Fetch failed');
  return response.json();
};

/**
 * Construit l'objet attendu par DocumentPreviewDialog ({ data, filename, sourceDoc })
 * à partir d'un document (id, filename). Retourne null si aucun contenu.
 */
export const buildHabilitationDocPreview = async (doc) => {
  const data = await fetchHabilitationDocument(doc.id);
  if (!data.content) return null;
  return {
    data: `data:${getHabilitationDocMimeType(data.file_type)};base64,${data.content}`,
    filename: data.filename || doc.filename,
    sourceDoc: { ...doc, filename: data.filename || doc.filename, file_type: data.file_type }
  };
};

/**
 * Télécharge un document d'habilitation dans le navigateur.
 */
export const downloadHabilitationDocument = async (docId, filename) => {
  const data = await fetchHabilitationDocument(docId);
  const byteCharacters = atob(data.content);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: getHabilitationDocMimeType(data.file_type) });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || data.filename || 'document';
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
